/**
 * tokens.css, read at runtime for Phaser. The CSS file stays the single source of truth; under
 * prefers-reduced-motion its media query already zeroes the motion tokens, so reading them here
 * picks that up too.
 */
import type { TypeName } from '@tdmons/sim';

function raw(name: string): string {
  const v = getComputedStyle(document.documentElement).getPropertyValue(`--${name}`).trim();
  if (v === '') throw new Error(`tokens.css has no --${name}`);
  return v;
}

/** A color token as CSS text, for Phaser Text styles. */
export const cssColor = (name: string): string => raw(name);

/** A `#rrggbb` color token as a number, for tints and fills. */
export function color(name: string): number {
  const v = raw(name);
  if (!/^#[0-9a-f]{6}$/i.test(v)) throw new Error(`--${name} is not #rrggbb: ${v}`);
  return parseInt(v.slice(1), 16);
}

/** A `ms` or `px` token as a number. */
export function num(name: string): number {
  const v = parseFloat(raw(name));
  if (!Number.isFinite(v)) throw new Error(`--${name} is not a number`);
  return v;
}

export const typeColor = (t: TypeName): number => color(`type-${t.toLowerCase()}`);

export const prefersReducedMotion = (): boolean =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;
